<template>
  <div class="py-5 container-fluid">
    <div class="row mt-4 justify-content-center">
      <div class="col-12">
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 text-start mt-3 mb-0">
          <button
            class="btn btn-outline-secondary btn-sm px-3 ms-2 mt-1"
            @click="$router.push({ name: 'LineVisits', params: { lineId: lineId } })"
          >
            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
            Go back to visits
          </button>
        </div>
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
          <div class="card-header mb-0 text-center">
            <h3 class="font-weight-bolder text-success text-gradient">Spray Pattern</h3>
            <h5
              v-if="line.name"
              class="mb-0"
            >
              for Line <i>{{ line.name }}</i>
            </h5>
            <p class="mt-4 mb-0 text-justify">Help BlueprintOS learn the Spray Pattern of your guns</p>
          </div>
        </div>
        <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column">
          <div class="row my-4">
            <div class="multisteps-form mt-4">
              <div class="multisteps-form__progress">
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Powder Selection"
                  :class="currentPage >= 0 ? activeClass : ''"
                  @click="updateCurrentPage(0)"
                >
                  1. Powder Selection
                </button>
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Spray Pattern Selection"
                  :class="currentPage >= 1 ? activeClass : ''"
                  @click="updateCurrentPage(1)"
                >
                  2. Spray Pattern Selection
                </button>
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Summary"
                  :class="currentPage >= 2 ? activeClass : ''"
                  @click="updateCurrentPage(2)"
                >
                  3. Summary
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="currentPage == 0"
          class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur"
        >
          <div class="card-header pb-0 text-center my-2">
            <h4 class="mb-4">
              <b>Select a Powder</b>
            </h4>
            <div
              class="d-flex align-items-center justify-content-between"
              style="gap: 16px"
            >
              <select
                id="choices-category"
                v-model="selected_powder_id"
                class="form-control mb-4 mr-2"
                style="flex: 1; min-width: 0; height: 48px; font-size: 1rem; border-radius: 8px"
                :disabled="visitFinalized"
                @change="updateSelectedPowder()"
              >
                <option
                  disabled
                  :value="null"
                >
                  {{ powders.length > 0 ? "Please select a powder" : "Please create a new powder" }}
                </option>
                <option
                  v-for="powder in powders
                    .slice()
                    .reverse()
                    .filter(powder => !isPowderGeneric(powder))"
                  :key="powder.id"
                  :value="powder.id"
                >
                  {{ powder.name }}
                </option>
              </select>
              <button
                v-if="currentPage === 0 && !visitFinalized"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#modal-form"
                class="btn btn-primary mb-4 ms-2"
                style="height: 48px; min-width: 200px; max-width: 300px; border-radius: 8px; white-space: nowrap"
              >
                Create a new Powder
              </button>
            </div>
          </div>
        </div>
        <Teleport to="body">
          <div
            v-if="currentPage === 0"
            id="modal-form"
            ref="modal"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
            style="z-index: 1050 !important"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-sm"
              role="document"
            >
              <div
                class="modal-content"
                style="text-align: left !important"
              >
                <div class="modal-body p-0">
                  <div class="card card-plain">
                    <div class="card-body justify-content-left">
                      <button
                        ref="dismissButton"
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label=""
                      ></button>
                      <form
                        role="form"
                        class=""
                      >
                        <label>Powder name</label>
                        <div class="input-group mb-3">
                          <input
                            v-model="newPowderName"
                            type="text"
                            :class="powder_name_input_error ? `form-control is-invalid` : `form-control`"
                            placeholder="Powder name"
                            :disabled="visitFinalized"
                            @input="powder_name_input_error = false"
                          />
                        </div>
                        <label>Powder Manufacturer</label>
                        <div class="input-group mb-3">
                          <input
                            v-model="newPowderManufacturer"
                            type="text"
                            :class="powder_manufacturer_input_error ? `form-control is-invalid` : `form-control`"
                            placeholder="Powder Manufacturer"
                            :disabled="visitFinalized"
                            @input="powder_manufacturer_input_error = false"
                          />
                        </div>
                        <label>Powder ID</label>
                        <p class="text-xs form-text text-muted ms-1 d-inline">(Optional)</p>
                        <div class="input-group mb-3">
                          <input
                            v-model="newPowderId"
                            type="text"
                            class="form-control"
                            placeholder="Powder ID"
                            :disabled="visitFinalized"
                          />
                        </div>
                        <div
                          v-if="!visitFinalized"
                          class="text-center"
                        >
                          <button
                            type="button"
                            class="btn bg-gradient-success btn-lg w-100 mt-4 mb-0"
                            @click="createPowder()"
                          >
                            Create Powder
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Teleport>
        <div
          v-if="currentPage == 1"
          class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur"
        >
          <div class="card-header pb-0 text-center my-3">
            <h4>
              <b>
                <b>Spray Pattern</b> for Powder <i>"{{ powder.name }}"</i>
              </b>
            </h4>
          </div>
          <div
            class="card-body pb-3 text-end"
            style="padding-top: 0.5rem"
          >
            <div class="col-12 ms-auto">
              <div class="d-flex justify-content-center gap-8">
                <button
                  type="button"
                  :class="`mt-2 mb-0 btn bg-gradient-${isCalibratedSprayPattern ? 'success' : 'gray'}`"
                  :disabled="visitFinalized"
                  style="width: 300px; height: 60px; background-color: rgb(241, 241, 241); word-break: keep-all"
                  @click="updateSprayPatternType('calibrated')"
                >
                  Use Calibrated Spray Pattern
                </button>
                <button
                  type="button"
                  :class="`mt-2 mb-0 btn bg-gradient-${isGenericSprayPattern ? 'success' : 'gray'}`"
                  :disabled="visitFinalized"
                  style="width: 300px; height: 60px; background-color: rgb(241, 241, 241); word-break: keep-all"
                  @click="updateSprayPatternType('generalprecalibrated')"
                >
                  Use Generic Spray Pattern
                </button>
              </div>
            </div>
            <div
              v-if="isCalibratedSprayPattern"
              class="d-flex flex-column"
            >
              <div
                v-if="selected_powder_id"
                class="row"
              >
                <PowderModelListBluePrint
                  :line-id="lineId"
                  :visit-id="visitId"
                  :powder-id="selected_powder_id"
                  @update-selected-spraypattern="updateSelectedSprayPattern($event, true)"
                />
              </div>
              <div
                v-if="!visitFinalized"
                class="text-center mt-3"
              >
                <button
                  class="btn bg-gradient-primary btn-sm px-4"
                  style="min-width: 180px; font-size: 1rem; height: 38px; background-color: #f1f1f1"
                  @click="
                    $router.push({
                      name: 'PowderModelAddBluePrint',
                      params: { lineId: lineId, visitId: visitId, powderId: selected_powder_id },
                    })
                  "
                >
                  Calibrate new Spray Pattern
                  <span style="font-size: 0.7rem"> (Estimated 10 mins) </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentPage == 2">
          <div class="col-14 ms-auto">
            <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
              <div class="card-body pt-4 mb-0">
                <div>
                  <h5 class="font-weight-bolder mb-2">Calibrated Spray Pattern Summary</h5>
                </div>
                <div class="row mt-4">
                  <div class="col-4">
                    <label class="mb-2 h6"> Powder name </label>
                    <div class="mt-2 mb-2 mx-2">
                      {{ powder.name }}
                    </div>
                  </div>
                  <div
                    v-if="isCalibratedSprayPattern && sprayPatternIsSelected"
                    class="col-4"
                  >
                    <label class="mb-2 h6">Selected Spray Pattern</label>
                    <div class="mt-2 mb-2 mx-2">
                      {{ spray_pattern ? spray_pattern.name : "No Spray Pattern selected" }}
                    </div>
                  </div>
                  <div
                    v-if="isCalibratedSprayPattern"
                    class="col-4"
                  >
                    <label class="mt-2 mb-2 h6">Calibrated line</label>
                    <div class="mt-2 mb-2 mx-2">
                      {{ line.name }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="isCalibratedSprayPattern"
                  class="accordion"
                >
                  <div class="accordion-item mb-0">
                    <h5 id="panelsStayOpen-headingOne">
                      <button
                        class="accordion-button collapsed mb-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseParams"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseParams"
                        style="padding: 0"
                      >
                        <p
                          class="font-weight-bolder mt-2"
                          style="
                            font-weight: 700 !important;
                            font-size: 1.05rem;
                            vertical-align: middle;
                            margin-bottom: 0;
                          "
                        >
                          Calibration Parameters
                          <i
                            class="fa fa-chevron-down"
                            aria-hidden="true"
                          ></i>
                          <i
                            class="fa fa-chevron-up"
                            aria-hidden="true"
                          ></i>
                        </p>
                      </button>
                    </h5>
                    <div
                      id="panelsStayOpen-collapseParams"
                      class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne"
                    >
                      <div
                        class="accordion-body"
                        style="padding: 0"
                      >
                        <div class="row">
                          <div
                            v-if="LoadedCalibrationMeasures"
                            class="col-4"
                          >
                            <label class="mt-2 mb-2"> Pistol to substrate distance </label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ powdermodel_calibration_measures.max_pistol_to_substrate_distance_measurements }}
                              [{{ $store.state.units_system[$store.state.user_data.unit_system].distance }}]
                            </div>
                          </div>
                          <div
                            v-if="LoadedCalibrationMeasures"
                            class="col-4"
                          >
                            <label class="mt-2 mb-2">
                              {{
                                LoadedLine ? `${line.air_parameter_name} ${line.air_parameter_units}` : "Air parameter"
                              }}
                            </label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ powdermodel_calibration_measures.max_air_parameter_measurements }}
                              {{ line.air_parameter_units }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 mb-2">Line speed</label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ calibrationLineSpeed }} [{{
                                $store.state.units_system[$store.state.user_data.unit_system].velocity_minutes
                              }}]
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-4">
                            <label class="mt-2 MB-2">
                              Powder Amount
                              <i
                                title="Quantity of powder dispensed by the gun per unit time"
                                class="fa fa-info-circle"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                data-container="body"
                                data-animation="true"
                              >
                              </i>
                            </label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ powderAmount }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 MB-2">Nozzle Type</label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ nozzleType }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 mb-2">Booth side used for calibration</label>
                            <div class="mt-2 mb-2 mx-2">{{ boothSide }}</div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-4">
                            <label class="mt-2 MB-2">Powder Manufacturer</label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ powder.powder_manufacturer }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 MB-2">Powder ID</label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ powder.powder_id }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 MB-2">{{ operationalHoursLabel }}</label>
                            <div class="mt-2 mb-2 mx-2">{{ pumpOperationalHours }} hours</div>
                          </div>
                        </div>
                        <div
                          v-if="this.$store.state.flightpath_pro_license"
                          class="row mt-2"
                        >
                          <div class="col-4">
                            <label class="mt-2 MB-2">Booth Temperature</label>
                            <div class="mt-2 mb-2 mx-2">
                              {{ boothTemperature }}
                              {{ $store.state.units_system[$store.state.user_data.unit_system].temperature }}
                            </div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 MB-2">Booth Humidity</label>
                            <div class="mt-2 mb-2 mx-2">{{ boothHumidity }} %</div>
                          </div>
                          <div class="col-4">
                            <label class="mt-2 MB-2">Guns Spacing</label>
                            <div class="mt-2 mb-2 mx-2">{{ gunsSpacing }}</div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-12">
                              <label class="mt-2 MB-2">Additional Info</label>
                              <div class="mt-2 mb-2 mx-2">
                                {{ additionalInfo }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item mb-0">
                    <h5 id="panelsStayOpen-headingOne">
                      <button
                        class="accordion-button collapsed mb-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseMeasurements"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseMeasurements"
                        style="padding: 0"
                      >
                        <p
                          class="font-weight-bolder"
                          style="
                            font-weight: 700 !important;
                            font-size: 1.05rem;
                            vertical-align: middle;
                            margin-bottom: 0;
                          "
                        >
                          Calibration Measurements
                          <i
                            class="fa fa-chevron-down"
                            aria-hidden="true"
                          ></i>
                          <i
                            class="fa fa-chevron-up"
                            aria-hidden="true"
                          ></i>
                        </p>
                      </button>
                    </h5>
                    <div
                      id="panelsStayOpen-collapseMeasurements"
                      class="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingOne"
                    >
                      <div
                        class="accordion-body"
                        style="padding: 0"
                      >
                        <div class="row">
                          <h6>Experiment 1</h6>
                          <div class="table-responsive w-90">
                            <table class="table table-sm table-bordered mt-1 mb-4">
                              <tbody>
                                <tr>
                                  <th>Point 1</th>
                                  <th>Point 2</th>
                                  <th>Point 3</th>
                                  <th>Point 4</th>
                                  <th>Point 5</th>
                                  <th>Point 6</th>
                                  <th>Point 7</th>
                                </tr>
                                <tr>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point1 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point2 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point3 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point4 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point5 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point6 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment1Point7 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h6>Experiment 2</h6>
                          <div class="table-responsive w-90">
                            <table class="table table-sm table-bordered mt-1 mb-4">
                              <tbody>
                                <tr>
                                  <th>Point 1</th>
                                  <th>Point 2</th>
                                  <th>Point 3</th>
                                  <th>Point 4</th>
                                  <th>Point 5</th>
                                  <th>Point 6</th>
                                  <th>Point 7</th>
                                </tr>
                                <tr>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point1 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point2 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point3 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point4 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point5 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point6 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                  <td style="border-width: 1px">
                                    {{ experiment2Point7 }} [{{
                                      $store.state.units_system[$store.state.user_data.unit_system].thickness_blueprint
                                    }}]
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur mt-3">
            <div class="card-header text-center">
              <h5 class="font-weight-bolder mb-0 pb-0">PowderModel visualization</h5>
            </div>
            <div class="card-body pt-0 d-flex justify-content-center">
              <div class="mr-4">
                <canvas
                  id="powdermodelcanvas"
                  class="w-100"
                  width="500"
                  height="500"
                  style="max-width: 500px"
                ></canvas>
                <div class="row">
                  <label>
                    The scale of this simulation is {{ lastSimulatedPowderDiameter }}x{{
                      lastSimulatedPowderDiameter
                    }}
                    [{{ $store.state.units_system[$store.state.user_data.unit_system].distance }}]</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex button-row mt-3">
        <soft-button
          v-if="currentPage == 1 || currentPage === 2"
          color="secondary"
          variant="gradient"
          class="btn js-btn-prev w-100 mb-0 me-2"
          style="min-width: 100px; max-width: 150px"
          title="Previous"
          @click="currentPage = currentPage - 1"
        >
          Previous
        </soft-button>
        <soft-button
          v-if="(currentPage !== 0 && sprayPatternIsSelected) || visitFinalized"
          type="button"
          :color="visitFinalized ? 'secondary' : 'warning'"
          variant="gradient"
          class="w-100 mb-0 me-2"
          :disabled="visitFinalized"
          style="min-width: 200px"
          @click="
            markVisitAsFinalized(visitId, 'finalized_at_spraypattern').then(() => {
              getVisit(visitId);
            })
          "
        >
          {{ visitFinalized ? "VISIT COMPLETED" : "MARK VISIT AS COMPLETED" }}
        </soft-button>
        <soft-button
          v-if="currentPage === 0"
          type="button"
          :color="selected_powder_id ? 'success' : 'secondary'"
          variant="gradient"
          class="js-btn-next mb-0 me-2 ms-auto"
          style="min-width: 100px"
          title="Next"
          @click="updateCurrentPage(currentPage + 1)"
        >
          Next &nbsp;&nbsp;<font-awesome-icon
            :icon="['fas', 'arrow-right']"
            inverse
          />
        </soft-button>
        <soft-button
          v-if="currentPage === 1"
          type="button"
          :color="sprayPatternIsSelected ? 'success' : 'secondary'"
          variant="gradient"
          class="js-btn-next mb-0 me-2 ms-auto"
          style="min-width: 100px"
          title="Next"
          @click="updateCurrentPage(currentPage + 1)"
        >
          Next &nbsp;&nbsp;<font-awesome-icon
            :icon="['fas', 'arrow-right']"
            inverse
          />
        </soft-button>
        <soft-button
          v-if="currentPage === 2"
          type="button"
          color="success"
          variant="gradient"
          class="js-btn-next mb-0 me-2"
          style="min-width: 380px"
          title="Continue to guns equalization"
          @click="
            $router.push({
              name: 'ReciprocatorOptimizationsLibrary',
              params: { lineId: lineId, visitId: visitId },
            })
          "
        >
          Continue to reciprocator optimization &nbsp;
          <font-awesome-icon
            :icon="['fas', 'circle-chevron-right']"
            size="lg"
          />
        </soft-button>
      </div>
    </div>
  </div>
  <div class="mx-auto col-xl-9 col-lg-10 col-md-11">
    <stepper-line-visit
      :line-id="lineId"
      :visit="visit"
      :finalized-at-stage="visit.finalized_at_stage"
    />
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
import PowderModelListBluePrint from "./components/PowderModelListBluePrint.vue";
import StepperLineVisit from "./components/StepperLineVisit.vue";
import { markVisitAsFinalized, useGetVisit, useGetLine, useGetPowders } from "@/views/composables.js";
import SoftButton from "../../../components/SoftButton.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowRotateLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";

library.add(faArrowRotateLeft, faCircleChevronRight);

const MAX_THICKNESS_METRIC_DECIMALS = 0;
const MAX_DISTANCE_METRIC_DECIMALS = 1;
const MAX_LINE_SPEED_METRIC_DECIMALS = 1;
const MAX_IMPERIAL_DECIMALS = 2;
const MAX_TEMPERATURE_DECIMALS = 1;

export default {
  name: "SprayPatternStage",
  components: {
    PowderModelListBluePrint,
    StepperLineVisit,
    SoftButton,
    FontAwesomeIcon,
  },
  props: {
    lineId: {
      type: String,
      default: null,
    },
    visitId: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { line, getLine } = useGetLine();
    const { visit, getVisit } = useGetVisit();
    const { powders, getPowders } = useGetPowders();

    return { line, getLine, visit, getVisit, powders, getPowders };
  },
  data() {
    {
      return {
        activeClass: "js-active position-relative",
        currentPage: 0,
        powder: {
          name: "",
          powder_manufacturer: "",
          powder_id: "",
        },
        selected_powder_id: null,
        newPowderName: "",
        powder_name_input_error: false,
        newPowderManufacturer: "",
        powder_manufacturer_input_error: false,
        newPowderId: "",
        precalibrated_powdermodel_id: null,
        spray_pattern: null,
        powdermodel_calibration_measures: [],
        powdermodelcanvas: null,
        distribution_imgData: null,
        powdermodel_visulization_params_form: {
          simulated_spray_diameter: 60,
          min_pistol_to_substrate_distance: 10,
          max_pistol_to_substrate_distance: 60,
          pistol_to_substrate_distance: 20,
          min_air_parameter_value: 1,
          max_air_parameter_value: 10,
          air_parameter_value: 2,
        },
        last_powdermodel_visualization_params: {
          simulated_spray_diameter: 60,
          min_pistol_to_substrate_distance: 10,
          max_pistol_to_substrate_distance: 60,
          pistol_to_substrate_distance: 20,
          min_air_parameter_value: 1,
          max_air_parameter_value: 10,
          air_parameter_value: 2,
        },
        spray_pattern_type: null,
      };
    }
  },
  computed: {
    sprayPatternIsSelected() {
      if (this.isGenericSprayPattern) {
        return true;
      }

      if (
        this.visit.spraypatternstage.selected_powder_model == null ||
        this.visit.spraypatternstage.selected_powder_model == undefined
      ) {
        return false;
      }
      return true;
    },
    isCalibratedSprayPattern() {
      return this.spray_pattern_type === "calibrated";
    },
    isGenericSprayPattern() {
      return this.spray_pattern_type === "generalprecalibrated";
    },
    visitFinalized() {
      return (
        this.visit.finalized_at_stage == "finalized_at_spraypattern" ||
        this.visit.finalized_at_stage == "finalized_at_reciprocator" ||
        this.visit.finalized_at_stage == "finalized_at_thicknessadjustment"
      );
    },
    visitFinalizedAtSprayPattern() {
      return this.visit.finalized_at_stage == "finalized_at_spraypattern";
    },
    LoadedCalibrationMeasures() {
      return Object.prototype.hasOwnProperty.call(this.powdermodel_calibration_measures, "powdermodel");
    },
    LoadedLine: function () {
      return Object.prototype.hasOwnProperty.call(this.line, "id");
    },
    powderAmount: {
      get() {
        if (
          this.powdermodel_calibration_measures.powder_amount == null ||
          this.powdermodel_calibration_measures.powder_amount == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.powder_amount;
        }
      },
    },
    boothSide: {
      get() {
        if (
          this.powdermodel_calibration_measures.booth_side == null ||
          this.powdermodel_calibration_measures.booth_side == ""
        ) {
          return "-";
        } else {
          return `${this.powdermodel_calibration_measures.booth_side} booth side`;
        }
      },
    },
    boothTemperature: {
      get() {
        if (
          this.powdermodel_calibration_measures.booth_temperature == null ||
          this.powdermodel_calibration_measures.booth_temperature == ""
        ) {
          return "-";
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.booth_temperature * this.$store.state.conversion_factors.c_to_f +
              this.$store.state.conversion_factors.c_to_f_offset
            ).toFixed(MAX_TEMPERATURE_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(this.powdermodel_calibration_measures.booth_temperature.toFixed(MAX_TEMPERATURE_DECIMALS));
        } else {
          return null;
        }
      },
    },
    boothHumidity: {
      get() {
        if (
          this.powdermodel_calibration_measures.booth_humidity == null ||
          this.powdermodel_calibration_measures.booth_humidity == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.booth_humidity;
        }
      },
    },
    gunsSpacing: {
      get() {
        if (
          this.powdermodel_calibration_measures.guns_spacing == null ||
          this.powdermodel_calibration_measures.guns_spacing == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.guns_spacing;
        }
      },
    },
    pumpOperationalHours: {
      get() {
        if (
          this.powdermodel_calibration_measures.pump_operational_hours == null ||
          this.powdermodel_calibration_measures.pump_operational_hours == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.pump_operational_hours;
        }
      },
    },
    nozzleType: {
      get() {
        if (
          this.powdermodel_calibration_measures.nozzles_type == null ||
          this.powdermodel_calibration_measures.nozzles_type == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.nozzles_type;
        }
      },
    },
    additionalInfo: {
      get() {
        if (
          this.powdermodel_calibration_measures.additional_info == null ||
          this.powdermodel_calibration_measures.additional_info == ""
        ) {
          return "-";
        } else {
          return this.powdermodel_calibration_measures.additional_info;
        }
      },
    },
    calibrationLineSpeed: {
      get() {
        if (
          this.powdermodel_calibration_measures.calibration_line_speed == null ||
          this.powdermodel_calibration_measures.calibration_line_speed == ""
        ) {
          return "-";
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.calibration_line_speed *
              this.$store.state.conversion_factors.m_to_ft
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.calibration_line_speed.toFixed(MAX_LINE_SPEED_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.calibration_line_speed = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.calibration_line_speed =
              value / this.$store.state.conversion_factors.m_to_ft;
          } else if (this.$store.state.user_data.unit_system === "metric") {
            this.powdermodel_calibration_measures.calibration_line_speed = value;
          } else {
            this.powdermodel_calibration_measures.calibration_line_speed = null;
          }
        }
      },
    },
    lastSimulatedPowderDiameter: {
      get() {
        if (
          this.last_powdermodel_visualization_params.simulated_spray_diameter == null ||
          this.last_powdermodel_visualization_params.simulated_spray_diameter == ""
        ) {
          return this.last_powdermodel_visualization_params.simulated_spray_diameter;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.last_powdermodel_visualization_params.simulated_spray_diameter *
              this.$store.state.conversion_factors.cm_to_in
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.last_powdermodel_visualization_params.simulated_spray_diameter.toFixed(MAX_DISTANCE_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.last_powdermodel_visualization_params.simulated_spray_diameter = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.last_powdermodel_visualization_params.simulated_spray_diameter =
              value / this.$store.state.conversion_factors.cm_to_in;
          } else if (this.$store.state.user_data.unit_system === "metric") {
            this.last_powdermodel_visualization_params.simulated_spray_diameter = value;
          } else {
            this.last_powdermodel_visualization_params.simulated_spray_diameter = null;
          }
        }
      },
    },
    operationalHoursLabel: {
      get() {
        if (this.line.pump_type == "injector_venturi") {
          return "Operational Hours Injector";
        } else if (this.line.pump_type == "dense_phase") {
          return "Operational Hours Since Last Maintanance";
        } else {
          return "Pump Operational Hours";
        }
      },
    },
    experiment1Point1: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_1 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_1 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_1;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_1 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_1.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_1 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_1 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_1 = value;
          }
        }
      },
    },
    experiment1Point2: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_2 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_2 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_2;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_2 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_2.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_2 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_2 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_2 = value;
          }
        }
      },
    },
    experiment1Point3: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_3 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_3 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_3;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_3 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_3.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_3 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_3 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_3 = value;
          }
        }
      },
    },
    experiment1Point4: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_4 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_4 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_4;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_4 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_4.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_4 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_4 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_4 = value;
          }
        }
      },
    },
    experiment1Point5: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_5 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_5 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_5;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_5 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_5.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_5 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_5 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_5 = value;
          }
        }
      },
    },
    experiment1Point6: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_6 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_6 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_6;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_6 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_6.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_6 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_6 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_6 = value;
          }
        }
      },
    },
    experiment1Point7: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_1_point_7 == null ||
          this.powdermodel_calibration_measures.experiment_1_point_7 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_1_point_7;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_1_point_7 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_1_point_7.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_1_point_7 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_1_point_7 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_1_point_7 = value;
          }
        }
      },
    },
    experiment2Point1: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_1 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_1 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_1;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_1 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_1.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_1 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_1 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_1 = value;
          }
        }
      },
    },
    experiment2Point2: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_2 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_2 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_2;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_2 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_2.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_2 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_2 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_2 = value;
          }
        }
      },
    },
    experiment2Point3: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_3 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_3 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_3;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_3 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_3.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_3 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_3 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_3 = value;
          }
        }
      },
    },
    experiment2Point4: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_4 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_4 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_4;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_4 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_4.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_4 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_4 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_4 = value;
          }
        }
      },
    },
    experiment2Point5: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_5 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_5 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_5;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_5 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_5.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_5 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_5 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_5 = value;
          }
        }
      },
    },
    experiment2Point6: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_6 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_6 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_6;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_6 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_6.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_6 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_6 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_6 = value;
          }
        }
      },
    },
    experiment2Point7: {
      get() {
        if (
          this.powdermodel_calibration_measures.experiment_2_point_7 == null ||
          this.powdermodel_calibration_measures.experiment_2_point_7 == ""
        ) {
          return this.powdermodel_calibration_measures.experiment_2_point_7;
        }
        if (this.$store.state.user_data.unit_system === "imperial") {
          return parseFloat(
            (
              this.powdermodel_calibration_measures.experiment_2_point_7 *
              this.$store.state.conversion_factors.um_to_mil
            ).toFixed(MAX_IMPERIAL_DECIMALS),
          );
        } else if (this.$store.state.user_data.unit_system === "metric") {
          return parseFloat(
            this.powdermodel_calibration_measures.experiment_2_point_7.toFixed(MAX_THICKNESS_METRIC_DECIMALS),
          );
        } else {
          return null;
        }
      },
      set(value) {
        if (value == null || value == "") {
          this.powdermodel_calibration_measures.experiment_2_point_7 = value;
        } else {
          if (this.$store.state.user_data.unit_system === "imperial") {
            this.powdermodel_calibration_measures.experiment_2_point_7 =
              value / this.$store.state.conversion_factors.um_to_mil;
          } else {
            this.powdermodel_calibration_measures.experiment_2_point_7 = value;
          }
        }
      },
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;

    this.getData();
    setTooltip();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    markVisitAsFinalized,
    async getCanvasData() {
      var canvas = document.getElementById("powdermodelcanvas");
      var ctx = canvas.getContext("2d");
      this.canvas_width = canvas.width;
      this.canvas_height = canvas.height;
      this.powdermodelcanvas = ctx;
      await this.drawDistribution();
    },
    async getData() {
      await this.getPrecalibratedPowderModelId();
      await Promise.all([this.getLine(this.lineId), this.getVisit(this.visitId), this.getPowders(this.lineId)]);

      this.getSprayPatternType();

      this.selected_powder_id = this.visit.benchmarkstage.powder ? this.visit.benchmarkstage.powder.id : null;

      if (this.powders.length == 1 && !this.isPowderGeneric(this.powders[0]) && !this.selected_powder_id) {
        this.selected_powder_id = this.powders[0].id;
        this.updateSelectedPowder();
      }

      if (this.selected_powder_id) {
        await this.getPowder();
        this.currentPage = 1;

        if (this.sprayPatternIsSelected) {
          this.currentPage = 2;
          await this.drawSprayPattern();
        }
      }
      this.$store.state.isLoading = false;
    },
    getSprayPatternType() {
      if (
        this.visit.spraypatternstage.is_generic_spray_pattern_used === undefined ||
        this.visit.spraypatternstage.is_generic_spray_pattern_used === null
      ) {
        this.spray_pattern_type = null;
      } else if (this.visit.spraypatternstage.is_generic_spray_pattern_used === true) {
        this.spray_pattern_type = "generalprecalibrated";
      } else if (this.visit.spraypatternstage.is_generic_spray_pattern_used === false) {
        this.spray_pattern_type = "calibrated";
      }

      if (
        this.visit.spraypatternstage.selected_powder_model != null &&
        this.visit.spraypatternstage.selected_powder_model == undefined &&
        this.spray_pattern_type !== "calibrated"
      ) {
        this.updateSprayPatternType("calibrated");
      }
    },
    async updateSprayPatternType(spray_pattern_type) {
      this.spray_pattern_type = spray_pattern_type;

      const is_generic_spray_pattern_used =
        spray_pattern_type != null ? spray_pattern_type === "generalprecalibrated" : null;
      await axios
        .patch(`/api/v1/blueprint/spraypattern/${this.visitId}/`, {
          is_generic_spray_pattern_used: is_generic_spray_pattern_used,
        })
        .catch(error => {
          console.error(error);
        });
    },
    async drawSprayPattern() {
      await this.getPowderModel();
      await this.getPowderCalibrationMeasures();
      await this.getCanvasData();
    },
    async getPowderModel() {
      try {
        if (!this.sprayPatternIsSelected) {
          return;
        }

        if (this.isCalibratedSprayPattern) {
          let response = await axios.get(
            "/api/v1/fp/powdermodels/" + this.visit.spraypatternstage.selected_powder_model,
          );
          this.spray_pattern = response.data;
        } else if (this.isGenericSprayPattern) {
          let response = await axios.get(
            "/api/v1/fp/generalprecalibratedpowdermodels/" + this.precalibrated_powdermodel_id + "/",
          );
          this.spray_pattern = response.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPrecalibratedPowderModelId() {
      try {
        const response = await axios.get("/api/v1/fp/generalprecalibratedpowdermodels/");
        this.precalibrated_powdermodel_id = response.data[0].id;
      } catch (error) {
        console.error(error);
      }
    },
    async updateSelectedSprayPattern(new_selected_powder_model_id, progress_status_completed = false) {
      const PROGRESS_STATUS_COMPLETED = "Completed";
      const PROGRESS_STATUS_IN_PROGRESS = "In Progress";

      await axios
        .patch(`/api/v1/blueprint/spraypattern/${this.visitId}/`, {
          selected_powder_model: new_selected_powder_model_id,
          progress_status: progress_status_completed ? PROGRESS_STATUS_COMPLETED : PROGRESS_STATUS_IN_PROGRESS,
        })
        .catch(error => {
          console.error(error);
        });
      this.visit.spraypatternstage.selected_powder_model = new_selected_powder_model_id;
    },
    async getPowderCalibrationMeasures() {
      try {
        if (
          this.isGenericSprayPattern ||
          !this.sprayPatternIsSelected ||
          this.spray_pattern == null ||
          this.spray_pattern.id == null ||
          this.spray_pattern.id == undefined ||
          this.spray_pattern.id == ""
        ) {
          return;
        }

        let response = await axios.get("/api/v1/fp/powdercalibrationmeasures/" + this.spray_pattern.id + "/");

        response.data.max_pistol_to_substrate_distance_measurements *= 100;
        response.data.min_pistol_to_substrate_distance_measurements *= 100;
        response.data.calibration_line_speed *= 60;
        this.powdermodel_calibration_measures = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    checkFilledCreatePowderForm() {
      if (this.newPowderName == "") {
        this.powder_name_input_error = true;
      }
      if (this.newPowderManufacturer == "") {
        this.powder_manufacturer_input_error = true;
      }
      if (this.powder_name_input_error || this.powder_manufacturer_input_error) {
        this.$swal({
          title: "Please fill in all required fields",
          icon: "error",
          customClass: {
            confirmButton: "btn bg-gradient-success",
          },
          buttonsStyling: false,
        });
        return false;
      }
      return true;
    },
    closeModal() {
      const dismissButton = this.$refs.dismissButton;
      if (dismissButton) {
        dismissButton.click();
      }
    },
    async updateSprayPatternStageToCompleted() {
      try {
        await axios
          .patch("/api/v1/blueprint/spraypattern/" + this.visitId + "/", {
            selected_powder_model: null,
            progress_status: "Completed",
          })
          .catch(error => {
            console.error(error);
          });
      } catch (error) {
        console.error(error);
      }
    },
    async createPowder() {
      if (!this.checkFilledCreatePowderForm()) {
        return;
      }

      try {
        const response = await axios.post("/api/v1/blueprint/powder/", {
          line: this.lineId,
          name: this.newPowderName,
          powder_manufacturer: this.newPowderManufacturer,
          powder_id: this.newPowderId,
        });

        this.selected_powder_id = response.data.id;
        await this.getPowders(this.lineId);
        await this.updateSelectedPowder();

        this.newPowderName = "";
        this.newPowderManufacturer = "";
        this.newPowderId = "";
      } catch (error) {
        console.error(error);
      }
      this.closeModal();
    },
    async drawDistribution() {
      this.$store.state.isLoading = true;
      this.fillCanvasBlue();

      var distribution = await this.getGeneralizedGaussianDistribution();
      this.distribution_imgData = new ImageData(
        Uint8ClampedArray.from(distribution.values()),
        this.canvas_width,
        this.canvas_height,
      );
      this.powdermodelcanvas.putImageData(this.distribution_imgData, 0, 0);

      this.last_powdermodel_visualization_params = Object.assign({}, this.powdermodel_visulization_params_form);

      this.$store.state.isLoading = false;
    },
    async getGeneralizedGaussianDistribution() {
      var distribution_window_pixel_size = this.canvas_width;
      var pixels_per_meter = Math.round(
        distribution_window_pixel_size / (this.powdermodel_visulization_params_form.simulated_spray_diameter / 100),
      );
      var body = {
        powdermodel_id: this.isGenericSprayPattern ? this.precalibrated_powdermodel_id : this.spray_pattern.id,
        powdermodel_type: this.spray_pattern_type,
        pistol_to_substrate_distance: parseFloat(
          this.powdermodel_visulization_params_form.pistol_to_substrate_distance / 100,
        ),
        air_parameter_value: parseFloat(this.powdermodel_visulization_params_form.air_parameter_value),
        distribution_window_pixel_size: parseFloat(distribution_window_pixel_size),
        pixels_per_meter: pixels_per_meter,
      };

      var response = await axios.post("/api/v1/fp/computegeneralizedgaussiandistribution/", body);

      return response.data["distribution"];
    },
    async updateCurrentPage(newPage) {
      if (newPage <= this.currentPage) {
        this.currentPage = newPage;
        return;
      }

      if (this.currentPage === 0 && (newPage === 1 || newPage === 2)) {
        // if user has not selected a powder, show a warning
        if (!this.selected_powder_id) {
          this.$swal({
            title: "Warning",
            text: "Please select a Powder before proceeding.",
            icon: "warning",
            customClass: {
              confirmButton: "btn bg-gradient-warning",
            },
            buttonsStyling: false,
          });
          return;
        }
      }

      if ((this.currentPage === 0 || this.currentPage === 1) && newPage === 2) {
        if (!this.sprayPatternIsSelected) {
          this.$swal({
            title: "Warning",
            text: 'Please select a Calibrated Spray Pattern or select "Use Generic Spray Pattern" before proceeding.',
            icon: "warning",
            customClass: {
              confirmButton: "btn bg-gradient-warning",
            },
            buttonsStyling: false,
          });
          return;
        }
      }

      this.currentPage = newPage;
      if (newPage === 2) {
        await this.drawSprayPattern();
      }
    },
    async updateSelectedPowder() {
      try {
        if (
          this.isCalibratedSprayPattern &&
          (this.selected_powder_id == null || this.selected_powder_id == "" || this.selected_powder_id == undefined)
        ) {
          return;
        }

        await axios.patch(`/api/v1/blueprint/benchmarkstage/${this.visitId}/`, { powder: this.selected_powder_id });

        await Promise.all([this.getVisit(this.visitId), this.getPowder(), this.updateSprayPatternType(null)]);

        this.updateSelectedSprayPattern(null, false);
      } catch (error) {
        console.error(error);
      }
    },
    fillCanvasBlue() {
      this.powdermodelcanvas.fillStyle = "#000080";
      this.powdermodelcanvas.fillRect(0, 0, this.canvas_width, this.canvas_height);
    },
    async getPowder() {
      try {
        const response = await axios.get("/api/v1/blueprint/powder/" + this.selected_powder_id);
        this.powder = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    isPowderGeneric(powder) {
      return powder.name.toLowerCase().includes("generic");
    },
  },
};
</script>
